export default "__VITE_ASSET__DPb2cAQf__"